export default __webpack_public_path__ + "static/bentoSectionBg6Mob-b0c8a498b157316cfd957550b034e4f9.webp";